import { uiActions, levelSelectors } from '~/store';
import { GAME_COMPLETED } from '~/store/game/actionTypes';
// ---- internal imports ----

function finalLevelCompleted(){
	return async (dispatch) => {
		dispatch({ type: GAME_COMPLETED });
		dispatch(uiActions.showNewLevelModal());
	};
};

export default finalLevelCompleted;
